export const sportsImagesAssetsUrl: string = 'https://static-assets.lvbet.lv/images/';
